import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _IconMicSolid, _IconMicOffLine;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { useCallback, useMemo } from 'react';
import { IconMicSolid, IconMicOffLine } from '@instructure/ui-icons';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DeviceSelection, { OFF_VALUE } from '../DeviceSelection';
import * as CaptureActions from '../../../actions';
import { translate } from '../../../constants/translated/translations';

/**
---
private: true
---
**/
function AudioDeviceSelection({
  audioDeviceId,
  devices,
  actions,
  isDisabled,
  mobile,
  labelledBy
}) {
  const isButtonDisabled = isDisabled || devices.length === 0 || devices.every(device => device.deviceId === '');
  const handleDeviceSelect = useCallback(newSelectedDeviceId => {
    if (!newSelectedDeviceId) return;
    if (newSelectedDeviceId === OFF_VALUE) {
      actions.audioDeviceDisabled();
      return;
    }
    actions.audioDeviceChanged(newSelectedDeviceId);
  }, [actions]);
  const devicesWithFixedLabels = useMemo(() => {
    return devices.map((device, index) => {
      const deviceInfo = device.toJSON();
      return _objectSpread(_objectSpread({}, deviceInfo), {}, {
        label: deviceInfo.label ? deviceInfo.label : `${translate('MICROPHONE')} ${index + 1}`
      });
    });
  }, [devices]);
  return /*#__PURE__*/React.createElement(DeviceSelection, {
    selectedDeviceId: audioDeviceId,
    devices: devicesWithFixedLabels,
    onDeviceSelected: handleDeviceSelect,
    label: translate('WEBCAM_AUDIO_SELECTION_LABEL'),
    icon: audioDeviceId ? _IconMicSolid || (_IconMicSolid = /*#__PURE__*/React.createElement(IconMicSolid, null)) : _IconMicOffLine || (_IconMicOffLine = /*#__PURE__*/React.createElement(IconMicOffLine, null)),
    offLabel: translate('MICROPHONE_DISABLED'),
    primaryLabel: labelledBy,
    isDisabled: isButtonDisabled,
    "data-testid": "AudioDeviceSelection",
    color: "primary-inverse",
    mobile: mobile
  });
}
const mapStateToProps = state => ({
  audioDeviceId: state.audioDeviceId,
  devices: state.devices.audioinput
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(CaptureActions, dispatch)
});
AudioDeviceSelection.defaultProps = {
  labelledBy: ''
};
export default connect(mapStateToProps, mapDispatchToProps)(AudioDeviceSelection);